import { useModalState } from "@clipboard-health/ui-components";
import { SIGN_NEW_AGREEMENT_PATH } from "@src/appV2/Agreements/paths";
import { RootPaths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { SignICAgreementBottomSheet } from "@src/appV2/redesign/ICAgreement/SignICAgreementBottomSheet";
import { ActionType } from "@store/session";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { useSession } from "../store/helperHooks";

export function SignICAgreementModal() {
  const dispatch = useDispatch();
  const { popups } = useSession();
  const history = useHistory();
  const modalState = useModalState();

  const shouldShow = popups?.ICAgreement?.visible ?? false;

  useEffect(() => {
    if (shouldShow) {
      modalState.openModal();
    } else {
      modalState.closeModal();
    }
  }, [shouldShow, modalState]);

  function handleDismiss() {
    logEvent(APP_V2_USER_EVENTS.SIGN_NEW_AGREEMENT_MODAL_DISMISS);
    dispatch({ type: ActionType.HIDE_IC_AGREEMENT_POPUP });
    modalState.closeModal();
  }

  function handleContinue() {
    logEvent(APP_V2_USER_EVENTS.SIGN_NEW_AGREEMENT_MODAL_CONTINUE);
    dispatch({ type: ActionType.HIDE_IC_AGREEMENT_POPUP });
    modalState.closeModal();
    history.push(`${RootPaths.HOME}/${SIGN_NEW_AGREEMENT_PATH}`);
  }

  return (
    <SignICAgreementBottomSheet
      modalState={modalState}
      onDismiss={handleDismiss}
      onContinue={handleContinue}
    />
  );
}
